import { render, staticRenderFns } from "./FixedAssetCategory.vue?vue&type=template&id=be55b044"
import script from "./FixedAssetCategory.vue?vue&type=script&lang=js"
export * from "./FixedAssetCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports